import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { countdownLabel } from "@/lib/promotions";

export const OfferCountdown = ({ promo, className = "", testId }) => {
  const [label, setLabel] = useState(() => countdownLabel(promo));
  useEffect(() => {
    const tick = () => setLabel(countdownLabel(promo));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [promo]);
  if (!label) return null;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full bg-amber-500 px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-wide text-white shadow-sm ${className}`}>
      <Timer className="h-3 w-3 animate-pulse" strokeWidth={2.5} /> {label}
    </span>
  );
};
